import { StdMapTileLayerFactory } from "./StdMapTileLayerFactory";
import { BlankMapTileLayerFactory } from "./BlankMapTileLayerFactory";
import { SeamlessphotoMapTileLayerFactory } from "./SeamlessphotoMapTileLayerFactory";
import { PaleMapTileLayerFactory } from "./PaleMapTileLayerFactory";
import { RoadKillHeatmapLayerFactory } from "./RoadKillHeatmapLayerFactory";
import { RoadStructuresBridgesLayerFactory } from "./RoadStructuresBridgesLayerFactory";
import { RoadStructuresTunnelsLayerFactory } from "./RoadStructuresTunnelsLayerFactory";
import { RoadStructuresShedsLayerFactory } from "./RoadStructuresShedsLayerFactory";
import { RoadStructuresCulvertsLayerFactory } from "./RoadStructuresCulvertsLayerFactory";
import { RoadStructuresPedestrianDecksLayerFactory } from "./RoadStructuresPedestrianDecksLayerFactory";
import { RoadStructuresOverheadSignagesLayerFactory } from "./RoadStructuresOverheadSignagesLayerFactory";
import { RoadStructuresPavementsLayerFactory } from "./RoadStructuresPavementsLayerFactory";
import { RoadStructuresEarthworksLayerFactory } from "./RoadStructuresEarthworksLayerFactory";
import { DrmNodeMapLayerFactory } from "./DrmNodeMapLayerFactory";
import { DrmLinkMapLayerFactory } from "./DrmLinkMapLayerFactory";
import { TraVosLayerFactory } from "./TraVosLayerFactory";
import { TrafficCongestionLayerFactory } from "./TrafficCongestionLayerFactory";
import { ODSumDeparturesLayerFactory } from "./ODSumDeparturesLayerFactory";
import { ODZoneLayerFactory } from "./ODZoneLayerFactory";
import { ILayerFactory } from "./ILayerFactory";
import { ETCLayerFactory } from "./ETCLayerFactory";
import { ODNodeLayerFactory } from "./ODNodeLayerFactory";
import { RoadAttributeLayerFactory } from "./RoadAttributeLayerFactory";
import { GeoJsonFactory } from "./GeoJsonFactory";
import { AccidentHotspotLayerFactory } from "./AccidentHotspotLayerFactory";
import { LargeVehicleGuidanceSectionLayerFactory } from "./LargeVehicleGuidanceSectionLayerFactory";
import { WeightHeightDesignatedRoadLayerFactory } from "./WeightHeightDesignatedRoadLayerFactory";
import { SpecialVehicleExemptLayerFactory } from "./SpecialVehicleExemptLayerFactory";
import { SpecialVehicleExemptPointLayerFactory } from "./SpecialVehicleExemptPointLayerFactory";
import { RoadkillLayerFactory } from "./RoadkillLayerFactory";
import { GeneralTrafficLayerFactory } from "./GeneralTrafficLayerFactory";

/**
 * layerFactotyマップクラス
 */
export class LayerFactory {
  /**
   * 全レイヤファクトリ取得
   */
  getLayerFactory(): Array<ILayerFactory> {
    const array = new Array<ILayerFactory>();
    array.push(this.StdMapTile);
    array.push(this.BlankMapTile);
    array.push(this.SeamlessphotoMapTile);
    array.push(this.PaleMapTile);
    array.push(this.GeoJson);
    array.push(this.ODDepartureAndArrival);
    array.push(this.ODZone);
    array.push(this.ODNode);
    array.push(this.DrmLinkMap);
    array.push(this.DrmNodeMap);
    array.push(this.LargeVehicleGuidanceSection);
    array.push(this.SpecialVehicleExempt);
    array.push(this.WeightHeightDesignatedRoad);
    array.push(this.RoadAttribute);
    array.push(this.ETC);
    array.push(this.GeneralTraffic);
    array.push(this.RoadStructuresEarthworks);
    array.push(this.RoadStructuresPavements);
    array.push(this.RoadStructuresOverheadSignages);
    array.push(this.RoadStructuresPedestrianDecks);
    array.push(this.RoadStructuresCulverts);
    array.push(this.RoadStructuresSheds);
    array.push(this.RoadStructuresTunnels);
    array.push(this.RoadStructuresBridges);
    array.push(this.SpecialVehicleExemptPoint);
    array.push(this.AccidentHotspot);
    array.push(this.TrafficCongestion);
    array.push(this.RoadKillHeatmap);
    array.push(this.Roadkill);
    array.push(this.TraVos);

    return array;
  }

  /** 国土地理院標準地図 */
  StdMapTile = new StdMapTileLayerFactory();
  /** 国土地理院白地図 */
  BlankMapTile = new BlankMapTileLayerFactory();
  /** 国土地理院航空写真 */
  SeamlessphotoMapTile = new SeamlessphotoMapTileLayerFactory();
  /** 国土地理院淡色地図 */
  PaleMapTile = new PaleMapTileLayerFactory();
  /** ヒートマップ地図 */
  RoadKillHeatmap = new RoadKillHeatmapLayerFactory();

  /** 点検データ（道路橋） */
  RoadStructuresBridges = new RoadStructuresBridgesLayerFactory();
  /** 点検データ（トンネル） */
  RoadStructuresTunnels = new RoadStructuresTunnelsLayerFactory();
  /** 点検データ（シェッド） */
  RoadStructuresSheds = new RoadStructuresShedsLayerFactory();
  /** 点検データ（大型カルバート） */
  RoadStructuresCulverts = new RoadStructuresCulvertsLayerFactory();
  /** 点検データ（横断歩道橋） */
  RoadStructuresPedestrianDecks =
    new RoadStructuresPedestrianDecksLayerFactory();
  /** 点検データ（門型標識等） */
  RoadStructuresOverheadSignages =
    new RoadStructuresOverheadSignagesLayerFactory();
  /** 点検データ（舗装） */
  RoadStructuresPavements = new RoadStructuresPavementsLayerFactory();
  /** 点検データ（特定道路⼟⼯構造物） */
  RoadStructuresEarthworks = new RoadStructuresEarthworksLayerFactory();

  /** DRMノードレイヤ */
  DrmNodeMap = new DrmNodeMapLayerFactory();
  /** DRMリンクレイヤ */
  DrmLinkMap = new DrmLinkMapLayerFactory();
  /** ETCレイヤ */
  ETC = new ETCLayerFactory();

  /** TraVosレイヤ */
  TraVos = new TraVosLayerFactory();
  /** 一般交通量調査データレイヤ */
  GeneralTraffic = new GeneralTrafficLayerFactory();
  /** 主要渋滞箇所レイヤ */
  TrafficCongestion = new TrafficCongestionLayerFactory();
  /** 交通事故統計情報レイヤ */
  AccidentHotspot = new AccidentHotspotLayerFactory();
  /** 大型車誘導区間レイヤ */
  LargeVehicleGuidanceSection = new LargeVehicleGuidanceSectionLayerFactory();
  /** 重さ・高さ指定道路レイヤ */
  WeightHeightDesignatedRoad = new WeightHeightDesignatedRoadLayerFactory();
  /** 特車通行許可不要区間レイヤ */
  SpecialVehicleExempt = new SpecialVehicleExemptLayerFactory();
  /** 特車通行許可不要区間_交差点レイヤ */
  SpecialVehicleExemptPoint = new SpecialVehicleExemptPointLayerFactory();
  /** ロードキルレイヤ */
  Roadkill = new RoadkillLayerFactory();
  /** OD量レイヤ */
  ODNode = new ODNodeLayerFactory();
  /** OD発集量レイヤ */
  ODDepartureAndArrival = new ODSumDeparturesLayerFactory();
  /** ODゾーン */
  ODZone = new ODZoneLayerFactory();

  /** 道路属性 */
  RoadAttribute = new RoadAttributeLayerFactory();

  /** ベクタ読み込み */
  GeoJson = new GeoJsonFactory();
}
